import { NAVER_MAP_CLIENT_KEY } from "../config/keys";

const NAVER_MAP_SCRIPT_ID = NAVER_MAP_CLIENT_KEY;

type LoadNaverMapOptions = {
  clientId: string;
  submodules?: string[];
};

export function loadNaverMap({
  clientId,
  submodules = [],
}: LoadNaverMapOptions): Promise<any> {
  if (!clientId) {
    return Promise.reject(new Error('NAVER_MAP_CLIENT_ID가 없습니다.'));
  }

  if (typeof window === 'undefined') {
    return Promise.reject(new Error('브라우저 환경에서만 사용할 수 있습니다.'));
  }

  if (window.naver?.maps) {
    return Promise.resolve(window.naver);
  }

  if (window.__naverMapLoadingPromise) {
    return window.__naverMapLoadingPromise;
  }

  window.__naverMapLoadingPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(NAVER_MAP_SCRIPT_ID) as HTMLScriptElement | null;

    if (existing) {
      existing.addEventListener('load', () => {
        if (window.naver?.maps) resolve(window.naver);
        else reject(new Error('네이버 지도 객체를 찾을 수 없습니다.'));
      });
      existing.addEventListener('error', () => {
        reject(new Error('네이버 지도 스크립트 로드에 실패했습니다.'));
      });
      return;
    }

    const script = document.createElement('script');
    script.id = NAVER_MAP_SCRIPT_ID;

    const params = new URLSearchParams({
      ncpKeyId: clientId,
    });

    if (submodules.length > 0) {
      params.set('submodules', submodules.join(','));
    }

    script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?${params.toString()}`;
    script.async = true;

    script.onload = () => {
      if (window.naver?.maps) resolve(window.naver);
      else reject(new Error('네이버 지도 객체를 찾을 수 없습니다.'));
    };

    script.onerror = () => {
      reject(new Error('네이버 지도 스크립트 로드에 실패했습니다.'));
    };

    document.head.appendChild(script);
  });

  return window.__naverMapLoadingPromise;
}